import * as React from "react";
import "./ConferenceView.component.css";
import { ConferenceViewItem } from "./conference-view-item/ConferenceViewItem.component";
import { useRemoteMicIndicator } from "../../../hooks/mic-indicator.hook";
import { useParticipantsStore } from "../../../store/participants.store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { placeholderUserlistEmpty, ttCloseConferenceButton, ttShowConferenceButton } from "../../../common-strings.util";
export function ConferenceView({ visible, dropDownVisible, showSessionName, leftMenuBar, rightMenuBar, onShowClicked, onCloseClicked }) {
    var _a;
    const [sessionName] = useState((_a = localStorage.getItem("session")) !== null && _a !== void 0 ? _a : undefined);
    const users = useParticipantsStore();
    const speakingUsers = useRemoteMicIndicator();
    const createUserList = () => {
        if (users.otherUsers().length > 0) {
            return users
                .otherUsers()
                .map((user, index) => React.createElement(ConferenceViewItem, { key: index, user: user, speaking: !!speakingUsers.find((u) => u.clientId === user.clientId) }));
        }
        else {
            return (React.createElement("div", { className: "conference-view-empty" },
                React.createElement("span", null, placeholderUserlistEmpty())));
        }
    };
    return (React.createElement("div", { className: `conference-view-container ${visible ? "conference-view-container-visible" : ""}` },
        leftMenuBar && React.createElement("div", { className: "conference-view-button-container-left" }, leftMenuBar),
        React.createElement("div", { className: "conference-view-scroll-container" },
            React.createElement("div", { className: "conference-view-user-list" }, createUserList())),
        rightMenuBar && React.createElement("div", { className: "conference-view-button-container-right" }, rightMenuBar),
        visible && showSessionName && sessionName && (React.createElement("div", { className: "conference-view-outer-left-container" },
            React.createElement("div", { className: "confenrence-view-session-name-container" },
                React.createElement("h2", { className: "confenrence-view-session-name" }, sessionName)))),
        (visible || dropDownVisible) && (React.createElement("div", { className: "conference-view-outer-right-container" },
            React.createElement("button", { className: "icon-button", onClick: visible ? onCloseClicked : onShowClicked, "data-tooltip": visible ? ttCloseConferenceButton() : ttShowConferenceButton(), "data-tooltip-position": "bottom-left" },
                React.createElement(FontAwesomeIcon, { icon: ["fas", visible ? "angle-double-up" : "angle-double-down"] }))))));
}
